// Auto-generated by scripts/sync-icons.ts. Do not edit by hand.
// Source: react-icons/hi -> HiUsers
import type { IconBaseProps } from "..";

export function HiUsers({ size, color, style, ...rest }: IconBaseProps) {
  const computedStyle = color ? { color, ...style } : style;
  const dim = size ?? "1em";
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 20 20"
      aria-hidden="true"
      width={dim}
      height={dim}
      {...rest}
      style={computedStyle}
    >
      <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
    </svg>
  );
}
